module.exports = __webpack_public_path__ + "img/case1.adced91e.png";